/* Small UI fixes for the draft theme. */
(function () {
  function bindStageSliders() {
    document.querySelectorAll('.swiper[class*="fcpro-slider"]').forEach(function (sw) {
      if (sw.__claudeStageClick) return;
      sw.__claudeStageClick = true;
      sw.addEventListener('click', function (e) {
        var slide = e.target.closest('.swiper-slide');
        var s = sw.swiper;
        if (!slide || !s || slide.classList.contains('swiper-slide-active')) return;
        e.preventDefault();
        e.stopPropagation();
        var idx = slide.getAttribute('data-swiper-slide-index');
        if (s.params.loop && idx !== null) {
          s.slideToLoop(parseInt(idx, 10));
        } else {
          s.slideTo(Array.prototype.indexOf.call(s.slides, slide));
        }
      }, true);
    });
  }

  function init() {
    bindStageSliders();
    setTimeout(bindStageSliders, 1500);
    setTimeout(bindStageSliders, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();